import type { ProgressSpinnerDesignTokens, ProgressSpinnerTokenSections } from '@primeuix/themes/types/progressspinner';

export const colorScheme: ProgressSpinnerTokenSections.ColorScheme = {
    light: {
        root: {
            colorOne: '{blue.500}',
            colorTwo: '{red.500}',
            colorThree: '{green.500}',
            colorFour: '{yellow.500}'
        }
    },
    dark: {
        root: {
            colorOne: '{blue.400}',
            colorTwo: '{red.400}',
            colorThree: '{green.400}',
            colorFour: '{yellow.400}'
        }
    }
};

export default {
    colorScheme
} satisfies ProgressSpinnerDesignTokens;